import React from "react";
import { useRef } from "react";

const AboutContent = () => {
  const img1Ref = useRef();
  const img2Ref = useRef();

  const animate1 = () => {
    const children = img1Ref.current.children;

    for (let i = 0; i < children.length; i++) {
      children[i].classList.add("hover");
    }
  };

  const removeAnimate1 = () => {
    const children = img1Ref.current.children;

    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("hover");
    }
  };

  const animate2 = () => {
    const children = img2Ref.current.children;

    for (let i = 0; i < children.length; i++) {
      children[i].classList.add("hover");
    }
  };

  const removeAnimate2 = () => {
    const children = img2Ref.current.children;

    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("hover");
    }
  };

  return (
    <>
      <div className="naboutContainer">
        <div className="nborder1"></div>
        <div className="nborder2"></div>
        <div className="nborder3"></div>
        <div className="nborder4"></div>

        {/* <div className="borderBoxOne"></div>
                <div className="borderBoxTwo"></div> */}

        <div className="naboutContentBox">
          <div className="nimg1" ref={img1Ref}>
            <div className="nimgHolder1"></div>
            <div className="nimgHolder3"></div>
            <div
              className="nimgHolder2"
              onMouseEnter={animate1}
              onMouseOut={removeAnimate1}
            >
              <img
                style={{ height: "100%", width: "100%" }}
                src="/img/pics/003.jpeg"
                alt="Karan Chawla"
              />
            </div>
          </div>
          <div className="nimg2" ref={img2Ref}>
            <div className="nimgHolder1"></div>
            <div className="nimgHolder3"></div>
            <div
              className="nimgHolder2"
              onMouseEnter={animate2}
              onMouseOut={removeAnimate2}
            >
              <img
                style={{ height: "100%", width: "100%" }}
                src="/img/pics/001.jpeg"
                alt="Karan Chawla"
              />
            </div>
          </div>

          <div className="npara1">
            <div className="subtitle">
              Professional Expertise and Passion for Learning
            </div>
            <div className="content">
              As a dedicated Full Stack Engineer with 5+ years of experience, I
              specialize in building high-performance web applications across
              monolithic, microservices, and event-driven architectures. Adept in
              both MERN and LAMP stacks, I have extensive hands-on experience
              deploying AI/algorithmic-driven automation workflows to enhance
              operational efficiency and scale products.
            </div>
            <div className="content">
              Throughout my career across Resident Interface and Tata Consultancy
              Services, I have consistently demonstrated proficiency in crafting
              robust web solutions, scaling conversion rates, automating document
              lifecycles, and integrating complex fintech ecosystems.
            </div>
          </div>

          <div className="npara2">
            <div className="subtitle">Geographic Flexibility</div>
            <div className="content">
              Originally hailing from the historic city of Jabalpur, Madhya
              Pradesh, I am currently based in the vibrant metropolis of Pune,
              Maharashtra. However, my enthusiasm for professional growth knows
              no bounds, and I am readily open to opportunities that may require
              relocation across different regions of India or globally.
            </div>
            <div className="subtitle">Collaborative Spirit</div>
            <div className="content">
              A firm believer in the power of teamwork, I actively support and
              collaborate with my peers to achieve collective goals. I thrive in
              dynamic environments where collaboration fosters creativity and
              innovation, and I derive immense satisfaction from contributing to
              the success of my team members.
            </div>
            <div className="subtitle">Academic Background</div>
            <div className="content">
              I am a proud alumnus of Vellore Institute of Technology (VIT), Bhopal,
              where I earned my Bachelor's degree in Computer Science and
              Engineering with a CGPA of 8.8 (2017 - 2021). This rigorous academic
              journey equipped me with a strong foundation in computer science
              principles, empowering me to excel in software engineering.
            </div>
          </div>
          <div className="npara3">
            <div className="subtitle">Career Aspirations</div>
            <div className="content">
              I am currently seeking a challenging career opportunity that
              offers both personal and professional growth prospects. I am eager
              to leverage my skills and experience in a role that not only
              allows me to contribute meaningfully to innovative projects but
              also provides avenues for continuous learning and advancement.{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutContent;
